import Vue from 'vue'
import Router from 'vue-router'

const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router);
var routes=[
	{
		path: '/',
		name: '首页',
		component: both("index"),
	},
	{
		path: '/course_list',
		name: '课程',
		component: both("course_list"),
	},
	{
		path: '/exhibition',
		name: '展览',
		component: both("exhibition"),
	},
	{
		path: '/news',
		name: '新闻公告',
		component: both("news"),
	},
	{
		path: '/collection',
		name: '典藏信息',
		component: both("collection"),
	},
	{
		path: '/academic',
		name: '学术研究',
		component: both("academic"),
	},
	{
		path: '/about',
		name: '关于我们',
		component: both("about"),
	},
	{
		path: '/detail',
		name: '详情',
		component: both("detail"),
	}
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js